import React from 'react'
import { useLoaderData } from 'react-router-dom'
import PostComponent from '../PageComponents/PostComponent'
export default function Posts () {
  const pageData = useLoaderData()
  return (
    <div className='flex flex-col overflow-x-hidden w-full m-auto gap-4 items-center justify-center'>
      {pageData && pageData.map((post, index) => <PostComponent key={index} {...post} />)}
    </div>
  )
}
